exports.components = {
  "component---src-pages-cenik-js": () => import("./../../../src/pages/cenik.js" /* webpackChunkName: "component---src-pages-cenik-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-kontakty-js": () => import("./../../../src/pages/kontakty.js" /* webpackChunkName: "component---src-pages-kontakty-js" */),
  "component---src-pages-svatby-js": () => import("./../../../src/pages/svatby.js" /* webpackChunkName: "component---src-pages-svatby-js" */),
  "component---src-pages-videoklipy-js": () => import("./../../../src/pages/videoklipy.js" /* webpackChunkName: "component---src-pages-videoklipy-js" */)
}

